import React from "react";
import ProfileImage from "../img/profile.jpg";

export default () => {
  return (
    <section id="about" className="about col-padding">
      <div className="container">
        <h1 className="heading-1 mt-1 text-white">About me</h1>
        <p className="heading-2">Information about the developer.</p>
        <div className="about d-flex">
          <div className="col mb-1">
            <p className="text-content">
              I am Daniel, a Web Developer that is constantly focused on the
              technology world, how things work and which way the world evolves.
            </p>
            <p className="text-content">
              I have always been very enthusiast by computers and this is why I
              decided to work in this field. Through this, in programming I
              found something that I can create new applications and also be in
              constant update.
            </p>
            <p className="text-content skills__title my-1">Skills</p>
            <div className="d-flex">
              <div className="col">
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> HTML
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> CSS
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> JavaScript
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> React
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> NodeJS
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> SQL
                </p>
              </div>
              <div className="col">
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> SASS - Styled
                  Components
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> Responsive Design
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> Git
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> Bootstrap
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> Photoshop
                </p>
                <p className="text-content skills__description">
                  <span className="skills__dot">•</span> Jest
                </p>
              </div>
            </div>
          </div>
          <div className="col mb-1">
            <div className="about__profile">
              <img
                src={ProfileImage}
                alt="Profile"
                className="about__profile-img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/components/About.js